export const getParsedPrice = (value) => value.replace(/€\s?|(,*)/g, '');

export const getParsedVolume = (value) => value.replace(/(,*)/g, '');
